import template from './nbu.html';
import controller from './nbu.controller';
import './nbu.scss';

let nbuComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default nbuComponent;



// WEBPACK FOOTER //
// ./client/app/common/forms/nbu/nbu.component.js